<ng-container *transloco="let t; read: 'settings'">
<h2 class="mbm">{{t('permissionRoles')}}</h2>
<kendo-grid
  [data]="permissionRoles"
  (edit)="editHandler($event)"
  (cancel)="cancelHandler($event)"
  (save)="saveHandler($event)"
  (remove)="removeHandler($event)"
  (add)="addHandler($event)"
  [style.maxHeight.px]="600"
>
  <ng-template kendoGridToolbarTemplate>
    <button kendoGridAddCommand>{{ t('add') }}</button>
  </ng-template>
  <kendo-grid-column field="name" [title]="t('name')">
    <ng-template kendoGridEditTemplate let-formGroup="formGroup">
      <kendo-formfield>
        <kendo-textbox [formControl]="formGroup.get('name')"></kendo-textbox>
        <kendo-formerror *ngIf="formGroup.get('name').hasError('required')">{{ t('isRequiredField') }}</kendo-formerror>
        <kendo-formerror *ngIf="formGroup.get('name').hasError('isNotUnique')">{{ t('nameMustBeUnique') }}</kendo-formerror>
      </kendo-formfield>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="description" [title]="t('description')"> </kendo-grid-column>

  <kendo-grid-command-column
    [title]="t('action')"
  >
    <ng-template kendoGridCellTemplate let-isNew="isNew">
      <button kendoGridEditCommand themeColor="primary">{{ t('edit') }}</button>
      <button kendoGridRemoveCommand>{{ t('remove') }}</button>
      <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
        {{ isNew ? t('add') : t('save') }}
      </button>
      <button kendoGridCancelCommand>
        {{ isNew ? t('discard') : t('cancel') }}
      </button>
    </ng-template>
  </kendo-grid-command-column>
  <ng-template kendoGridDetailTemplate let-dataItem>
    <app-permission-role-edit
      [permissionId]="dataItem.id"
    >
    </app-permission-role-edit>
  </ng-template>
</kendo-grid>

<app-delete-confirm-dialog
  [(opened)]="deletionDialogOpened"
  [message]="t('deletionMessages.permissionRole')"
  (confirmed)="deleteConfirmed()"
></app-delete-confirm-dialog>
</ng-container>
